/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 *
 * Modifications copyright (C) 2019 LBI Software
 */
import "core-js/es6";
import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "./index.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/css/v4-shims.css";
import "./React-Data-Grid-Overrides.scss";
import App from "./App";
import registerServiceWorker, { unregister } from "./registerServiceWorker";

/* global document */
/* eslint-disable react/jsx-filename-extension */

ReactDOM.render(<App />, document.getElementById("root"));
if (process.env.REACT_APP_ENV === "production" || process.env.REACT_APP_ENV === "prod") {
  registerServiceWorker();
} else {
  unregister();
}
